export const ContentTypes = {
    JSON: "application/json"
}

export const StatusCodes = {
	OK: 200,
	ServiceUnavailable: 503,
	EndpointNotFound: 2001,
	NativeBindingError: 2002,
	UnknownError: -1,
};

//HTTP verbs
export const POST_METHOD = "POST";

//Endpoints
export const GET_ROOT_METADATA = "getRootMetadata";
export const GET_CHILDREN_METADATA = "getChildrenMetadata";
export const GET_FILE = "getFile";
export const GET_FILES = "getFiles";

//Headers
export const CUSTOMER_ID_HEADER = "X-XD-CustomerId";
export const CONTENT_TYPE_HEADER = "Content-Type";
export const TRANSACTION_ID_HEADER = "Citrix-TransactionId"
export const CORRELATION_ID_HEADER = "Citrix-CorrelationId";
export const IGNORE_AUTH_HEADER = "Citrix-Ignore-Auth-Challenge";

//Miscelllaneous
export const GLOBAL_NAMESPACE = "CtxWeb";
export const MODULE_NAMESPACE = "CLSyncEngine";

// CLSync cycle statuses
export const CLSYNC_PASS = "clsync_pass";
export const CLSYNC_PARTIAL = "clsync_partial";
export const CLSYNC_FAIL = "clsync_fail";
